import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { current_year, support_mail, support_number } from "../../utils/constant";
import { image_urls } from "../../utils/api-urls";

const usefulLinksData = [
    { name: "Home", hash: "#home" },
    { name: "About", hash: "#about" },
    { name: "Types of Reports", hash: "#reports" },
    { name: "Iris Analysis Benefit", hash: "#benefits" },
    { name: "Business Opportunity", hash: "#business" },
    { name: "Testimonials", hash: "#community" },
    { name: "FAQ", hash: "#faq" },
];

const policyLinksData = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Return/Refund Policy", path: "/refund-policy" },
    { name: "Shipping Policy", path: "/shipping-policy" },
    { name: "Terms and Conditions", path: "/terms-of-use" },
];

const socialLinks = [];

function PartnerFooter() {
    const location = useLocation();
    const navigate = useNavigate();
    const { partnerDetails } = useSelector(state => state?.partnerReducer);

    const handleHashClick = (e, hash) => {
        e.preventDefault();
        const sectionId = hash.substring(1);
        if (sectionId === 'home') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    const handlePageClick = (e, path) => {
        e.preventDefault();
        navigate(`${path}${location.search}`);
    };

    return (
        <footer className="bg-[#0f0d1a] text-gray-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">

                    <div className="space-y-6">
                        <div className="flex items-center gap-2 cursor-pointer" onClick={(e) => handleHashClick(e, '#home')}>
                            <img src={partnerDetails?.business_logo ? image_urls + partnerDetails.business_logo : "/logo.png"} alt="logo" className="w-10 h-10" />
                            <span className="text-xl font-bold text-white">{partnerDetails?.partner_name || 'IrisAnalysis'}</span>
                        </div>
                        <p className="text-gray-400 leading-relaxed text-justify">
                            Iris Analysis, powered by AI (Artificial Intelligence) and affiliated with American Research Institute of Dermis & Genetic Evaluation, is a scientific assessment of 100 Billion Neurons of a person's brain that reveals the Pre-natal Unique Abilities & Inherent talent of the person. Know your Best & beat the Rest!
                        </p>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-white">Useful Links</h4>
                        <ul className="space-y-4">
                            {usefulLinksData.map(link => (
                                <li key={link.name}>
                                    <a href={link.hash} onClick={(e) => handleHashClick(e, link.hash)} className="flex items-center gap-3 text-gray-400 hover:text-purple-400 transition cursor-pointer">
                                        <span className="w-2 h-2 rounded-full bg-purple-500" /> {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-white">Policies</h4>
                        <ul className="space-y-4">
                            {policyLinksData.map(item => (
                                <li key={item.name}>
                                    <a href={item.path} onClick={(e) => handlePageClick(e, item.path)} className="flex items-center gap-3 text-gray-400 hover:text-purple-400 transition cursor-pointer">
                                        <span className="w-2 h-2 rounded-full bg-purple-500" /> {item.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-white">Contact us</h4>
                        <ul className="space-y-4">

                            <li>
                                <a href={`mailto:${partnerDetails?.email || support_mail}`} className="flex items-center gap-3 text-gray-400 hover:text-purple-400 transition">
                                    <Mail className="w-5 h-5 text-purple-400" /> {partnerDetails?.email || support_mail}
                                </a>
                            </li>

                            <li className="flex items-start gap-3">
                                <MapPin className="w-5 h-5 text-purple-400 mt-1" />
                                <span className="text-gray-400">
                                    Address : Brainoglyphics RPS 12th Avenue World Trade Center, Delhi-Mathura Road, Faridabad – 121002
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>

            <div className="border-t border-gray-700">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <p className="text-center text-gray-500 text-sm">
                        Copyright Contents - All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default PartnerFooter;
